import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { css, cx } from '@bd/bdui-styles/emotion';
import AccordionToggle from '../../components/AccordionToggle';
import { colors } from '../../styles';

const styles = css`
.SectionLogos_section{
  @media(min-width: 768px){
    padding-top: 100px;
  }
}
.SectionLogos_logoWrapper{
  height:auto;
  margin-bottom: 30px;
}
.SectionLogos_logo{
  width: 100%;
  border: solid 1px ${colors.color1};
  padding: 10px;
}
.SectionLogos_descriptionHead{
  text-align: center;
}
`;


function SectionFeatures({ className, widget }) {
  return (
    <div className={cx(styles, className)}>
      <AccordionToggle
        openOnId="partners"
        button="Partners"
        id="partners"
      >
        <section className="SectionLogos_section">
          <h2 className="CommunityDetail_sectionHead SectionLogos_descriptionHead GoldText">
            Partners</h2>
          <div className="row justify-content-center">
            {
              widget.logo_gallery && widget.logo_gallery.length > 0 &&
              widget.logo_gallery.map(logo => (
                <div key={logo.contentUrl} className="SectionLogos_logoWrapper col-6 col-md-4 d-flex justify-content-center">
                  <img src={logo.contentUrl} alt="" className="SectionLogos_logo" />
                </div>
              ))
            }
          </div>
        </section>
      </AccordionToggle>
    </div>
  );
}

SectionFeatures.propTypes = {
  className: PropTypes.string,
  widget: PropTypes.object.isRequired,
};

SectionFeatures.defaultProps = {
  className: undefined,
};

export default withData({
  widget: 'communities',
})(SectionFeatures);



// WEBPACK FOOTER //
// ./src/pages/CommunityDetail/SectionLogos.js